let refreshHandler = null;
let signoutHandler = null;
const LOGIN_PATH = '/login';

export function getStoredToken() {
  const token = localStorage.getItem('token');

  if (!token || token === 'undefined') {
    return null;
  }

  return token;
}

export function setStoredToken(token) {
  localStorage.setItem('token', token);
}

export function clearStoredToken() {
  localStorage.removeItem('token');
}

export function registerAuthSessionHandlers({ refreshAccessToken, signout }) {
  refreshHandler = refreshAccessToken;
  signoutHandler = signout;

  return () => {
    if (refreshHandler === refreshAccessToken) {
      refreshHandler = null;
    }

    if (signoutHandler === signout) {
      signoutHandler = null;
    }
  };
}

export function requestSessionRefresh() {
  if (refreshHandler === null) {
    return Promise.reject(new Error('No refresh handler registered'));
  }

  return refreshHandler();
}

function redirectToLogin() {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname === LOGIN_PATH) {
    return;
  }

  if (process.env.NODE_ENV !== 'test' && window.location && typeof window.location.replace === 'function') {
    try {
      window.location.replace(LOGIN_PATH);
      return;
    } catch (error) {
    }
  }

  window.history.replaceState({}, '', LOGIN_PATH);

  const navigationEvent = typeof window.PopStateEvent === 'function'
    ? new window.PopStateEvent('popstate')
    : new window.Event('popstate');

  window.dispatchEvent(navigationEvent);
}

export function handleUnauthorizedSession() {
  clearStoredToken();

  if (signoutHandler !== null) {
    signoutHandler();
  }

  redirectToLogin();
}
